<div class="mainContainer">
  <div class="innerContainer">
    <div class="header">
      <div class="editorName">
        <div class="svgEditorIcon">
          <i class="fas fa-palette"></i>
        </div>
        <div class="name">SVG Editor</div>
      </div>
      <!-- <div class="reportIssue">Report an issue</div> -->
    </div>
    <div class="editorBody">
      <div class="leftbar">
        <div class="editingOption" *ngIf="fileSelected&&!tilesSelected">
          <div class="color-grid">
            <div *ngFor="let color of uniquesvgColors; let i = index">
              <input [colorPicker]="svgColors[i]" [style.background]="svgColors[i]" [cpToggle]="false"
                (cpSliderDragEnd)="onColorChange($event,i)" class="color-picker2" />
            </div>
          </div>
          <div class="color-Pallete">
            <div class="text-sm mt-1">
              <span class="font-bold">Note:</span> Click the icon to edit any part colors.
            </div>
            <div class="palleteHeading">
              Add colors from pallete
            </div>
            <div class="palletes">
              <button class="palleteButton" *ngFor="let pallete of colorPalettes; let i = index"
                (click)="onPalletechanging(pallete)">
                <div class="palleteNo">
                  #{{ i + 1 }}
                </div>
                <div class="palleteColors">
                  <div class="coloring" *ngFor="let color of pallete; let j = index" [style.background-color]="color"
                    [ngClass]="{ 'palleteFirstColor': j === 0, 'palleteLastColor': j === pallete.length - 1 }"></div>
                </div>
              </button>
              <div class="DownloadPallet">
                <button (click)="loadNextPaletteBatch(20)" class="DownloadButton">Load More</button>
              </div>
            </div>
          </div>
        </div>
        <div class="uploadedIcons" *ngIf="!fileSelected&&!tilesSelected">
          <div class="searchBar">
            <i class="search-icon">
              <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                class="ui-svg-inline searchIcon_T9jlL">
                <path
                  d="M21.71,20.29,18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z">
                </path>
              </svg>
            </i>
            <input type="text" (change)="onSearch($event)" placeholder="Search {{activeTab}}">

          </div>
          <div
            class="flex items-center justify-center gap-3 bg-[#F9F9F9] p-1 rounded-full font-medium text-base leading-normal text-[#8D8D8D] text-nowrap mt-1">
            <a href="javascript:void(0)" (click)="setsTab(lisenceEnum.Free)" [ngClass]="activesClass (lisenceEnum.Free)"
              class="cursor-pointer px-5 py-2 hover:bg-[#FFFFFF] rounded-full hover:text-[#121212]">
              <span>{{lisenceEnum.Free}}</span>
            </a>
            <a href="javascript:void(0)" (click)="setsTab(lisenceEnum.Premium)"
              [ngClass]="activesClass (lisenceEnum.Premium)"
              class="cursor-pointer px-5 py-2 hover:bg-[#FFFFFF] rounded-full hover:text-[#121212]">
              <span>{{lisenceEnum.Premium}}</span>
            </a>
          </div>
          <div>
            <ul
              class="cursor-pointer flex text-base font-medium text-black leading-5 font-Inter space-x-6 my-6">
              @for (item of categoriesTabs; track $index) {
              <li class="cursor-pointer" (click)="setTab(item)" [ngClass]="activeClass(item)">{{item}}</li>
              }

            </ul>
          </div>
          @if(loading){
          <div class="grid gap-4 grid-cols-[repeat(2,minmax(134px,1fr))]">
            @for (item of skeletonLoaderItems(4); track $index) {
            <div class="rounded-2xl h-[95px] w-[120px]">
              <div class="w-full h-full bg-gray-200 rounded mb-2 animate-pulse"></div>
            </div>
            }
          </div>
          }
          @else{
          @for (item of categoriesTabs; track $index) {
          @if(activeTab===item){
          <div class="pb-14">
            @for(asset of assets; track $index){
            <div class="icon-grid" [ngClass]="!total ? 'notFoundBox' : 'icon-grid'">

              @for(item of asset.iconPackDetails; track trackByIconPackDetailID($index, item)){
              <div class="icon-card relative" id="svgimage">
                @if(item.lisenceName===lisenceEnum.Premium){
                <div class="badge-container absolute top-2 left-1">
                  <svg viewBox="0 0 512 512" class="crown-badge" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#FFD700"
                      d="M486.2 50.2c-9.6-3.8-20.5-1.3-27.5 6.2l-98.2 125.5-83-161.1C273 13.2 264.9 8.5 256 8.5s-17.1 4.7-21.5 12.3l-83 161.1L53.3 56.5c-7-7.5-17.9-10-27.5-6.2C16.3 54 10 63.2 10 73.5v333c0 35.8 29.2 65 65 65h362c35.8 0 65-29.2 65-65v-333c0-10.3-6.3-19.5-15.8-23.3z" />
                  </svg>
                </div>
                }
                <app-svg-canvas  [tilte]="item.title + ' ' + item.categoryName"  [width]="95" [height]="75" (click)="loadSvgFromUrl(item.filePath,item)"
                  [filePath]="item.filePath! | blobUrl" [isRefresh]="true"
                  class="cursor-pointer"></app-svg-canvas>
              </div>
              }
              @if (!total && !isContentPreparing) {
              <app-no-record-found [title]="'No icons found'"
                [description]="'We couldn’t find any icons matching your search. Try a different keyword.'">
              </app-no-record-found>
              }
            </div>
            }
            @if (assetsPaginated?.hasNext) {
            <div class="flex gap-2 justify-center items-center mt-1 mb-1">
              <a class="bg-themeBlackTwo text-white font-semibold text-base rounded-full py-3 px-5 flex justify-center items-start cursor-pointer"
                (click)="viewMore()">Load More</a>
            </div>
            }
            @if(isContentPreparing){
            <div class="flex gap-2 justify-center items-center mt-1">
              <img src="../../../../../../../../assets/theme/images/logo/logo.svg"
                class="pt-[14px] animate-bounce" alt="loading">
              <span class="text-[18px] leading-5 font-semibold text-black">Loading Assets...</span>
            </div>
            }

          </div>
          }
          }
          }
        </div>

        <div class="tilesScreen" *ngIf="tilesSelected&&fileSelected">
          <div class="tiles tilesPart">
            <div class="tilesHeading">
              AddTiles
            </div>
            <div class="tilesStyle">
              <div class="style">
                <div class="shape none" (click)="backgroundShape='none';addSVGBackground()"></div>
                <div class="text">None</div>
              </div>
              <div class="style">
                <div class="shape square" (click)="backgroundShape='square';addSVGBackground()"></div>
                <div class="text">Square</div>
              </div>
              <div class="style">
                <div class="shape squircle" (click)="backgroundShape='squircle';addSVGBackground()"></div>
                <div class="text">Squircle</div>
              </div>
              <div class="style">
                <div class="shape circle" (click)="backgroundShape='circle';addSVGBackground()"></div>
                <div class="text">Circle</div>
              </div>
              <div class="style">
                <div class="shape Oval" (click)="backgroundShape='oval';addSVGBackground()"></div>
                <div class="text">Oval</div>
              </div>

            </div>
          </div>
          <div class="tilesColor tilesPart">
            <div class="tilesHeading tilesColorHeading">
              TilesColor
            </div>
            <div class="tilesColorPicker">
              <div class="colorPicker">
                <input type="color">
              </div>
              <div class="color" [style.backgroundColor]="color" (click)="backgroundColor=color;addSVGBackground()"
                *ngFor="let color of tilesColor,let i=index"></div>
            </div>
          </div>
          <div class="tileSize tilesPart">
            <div class="tilesHeading iconSize">
              Icon Size
            </div>
            <div class="iconTilesSize">
              <div class="iconSize">
                <label for="customRange1" class="block mb-1 text-sm font-medium">Icon Size</label>
                <input type="range" min="0" max="300" class="w-full accent-black" id="customRange1" (input)="svgSizes($event)">
              </div>
              <div class="tileSize">
                <label for="customRange1" class="block mb-1 text-sm font-medium">Tile Size</label>
                <input type="range" min="0" max="300" class="w-full accent-black" id="customRange1" (input)="sendData($event)">
              </div>

            </div>
          </div>
        </div>

      </div>
      <div class="rightbar">
        <div class="editorTiles" *ngIf="fileSelected">
          <button (click)="showTilesOption()">Tiles Editor</button>
          <div class="colorTheme" (click)="tilesSelected=false">
            <div class="color color1"></div>
            <div class="color color2"></div>
            <div class="color color3"></div>
            <div class="color color4"></div>
          </div>
          <div style="margin-bottom:13px;margin-left:15px;" class="flex gap-2 mt-4 ml-3">
            <button class="bg-gray-200 rounded px-2" (click)="undo()"><svg width="1em" height="1em"
                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="ui-svg-inline">
                <path
                  d="M17,9.5H7.41l1.3-1.29A1,1,0,0,0,7.29,6.79l-3,3a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l3,3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L7.41,11.5H17a1,1,0,0,1,1,1v4a1,1,0,0,0,2,0v-4A3,3,0,0,0,17,9.5Z">
                </path>
              </svg></button>
            <button class="bg-gray-200 rounded px-2" (click)="redo()"><svg width="1em" height="1em"
                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="ui-svg-inline">
                <path
                  d="M19.92,10.12a1,1,0,0,0-.21-.33l-3-3a1,1,0,1,0-1.42,1.42l1.3,1.29H7a3,3,0,0,0-3,3v4a1,1,0,0,0,2,0v-4a1,1,0,0,1,1-1h9.59l-1.3,1.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l3-3a1,1,0,0,0,.21-.33A1,1,0,0,0,19.92,10.12Z">
                </path>
              </svg></button>

            <button (click)="resetEditor()"
              class="flex items-center bg-black text-black px-4 py-2 rounded-full relative">Undo</button>
            <button (click)="clear()"
              class="flex items-center bg-black text-black px-4 py-2 rounded-full relative">Reset</button>
          </div>
        </div>
        <div class="SvgEditorMainContainer" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)">
          <div class="BrowseOption"  *ngIf="!fileSelected" [class.dragover-active]="isDragOver">

            <div class="icon">
              <i class="fa-solid fa-cloud-arrow-up"></i>
            </div>
            <div class="text">
              Drag and drop your svg here <br> or
            </div>
            <div class="button">
              <input type="file" #fileInput accept=".svg, image/svg+xml" (change)="onFileChange($event)">
              <button (click)="triggerFileInput()">Browse</button>
            </div>
            @if (fileError) {
            <span class="text-danger">{{fileError}}</span>
            }
          </div>
           
          <div class="SVGFileOption" id="svgDisplay" *ngIf="fileSelected">

          </div>
        </div>

        <div class="DownloadBar">
          <ng-container>
            <div class="button">
              <input type="file" #fileInput accept=".svg, image/svg+xml" (change)="onFileChange($event)">
              <button class="NewSvgButton" (click)="triggerFileInput()">Upload New SVG</button>
            </div>
          </ng-container>
          <div class="grid gap-x-1.5 gap-y-3 transition-all duration-700 ease-in-out">
            <button [disabled]="!fileSelected" (click)="iconDownload()"
              class="cursor-pointer flex items-center bg-black text-white px-4 py-2 rounded-full relative flex-1">
              <!-- Label -->
              <span class="font-medium w-full flex justify-center items-center">Download
                @if(isIconDownloading){
                <span
                  class="border-white h-4 w-4 animate-spin rounded-full border-2 border-t-black ms-2"></span>
                }
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>